interface SquiggleProps {
  color: string;
}

export const Squiggle = ({ color }: SquiggleProps) => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 613.555 228.3'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ display: 'block' }}
  >
    <path
      d='M613.555 114.347H577.159C577.159 71.3644 542.239 36.5176 499.166 36.5176C456.093 36.5176 421.173 71.3644 421.173 114.347H421.162C421.058 177.295 369.895 228.3 306.772 228.3C243.65 228.3 192.383 177.192 192.383 114.15C192.383 71.1672 157.473 36.3204 114.39 36.3204C71.3064 36.3204 36.3967 71.1672 36.3967 114.15H0C0 51.108 51.2154 0 114.39 0C177.564 0 228.779 51.108 228.779 114.15C228.779 157.132 263.7 191.979 306.772 191.979C349.845 191.979 384.766 157.132 384.766 114.15H384.776C384.88 51.2014 436.043 0.197168 499.166 0.197168C562.288 0.197168 613.555 51.3051 613.555 114.347Z'
      fill={color}
    />
  </svg>
);
